<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Erlaubte Versionen konfigurieren</h4>
        </div>
      </div>
    </div>
    <div>
      <div class="card p-5">
          <div class="form-group">
              <label class="form-label">Update erforderlich ab:</label>
              <input class="form-control" type="text" placeholder="z. B. 1.2.3" v-model="versions.minimum" v-bind:class="{'is-invalid': minimumInvalid}">
              <!-- Ein Tippfehler in diesem Feld wirkt still: Der Server kann daraus
                   keine sinnvolle Vergleichsgrundlage bilden, meldet aber keinen
                   Fehler zurück. Was dann tatsächlich passiert, steht ausführlich
                   im Kommentar über isValidVersionFormat weiter unten. -->
              <small class="text-danger" v-if="minimumInvalid && versions.minimum">Bitte nur Ziffern und Punkte eingeben, z. B. 1.2.3.</small>
          </div>
          <div class="form-group">
              <label class="form-label">Update empfehlen ab:</label>
              <input class="form-control" type="text" placeholder="z. B. 1.2.3" v-model="versions.recommend" v-bind:class="{'is-invalid': recommendInvalid}">
              <small class="text-danger" v-if="recommendInvalid">Bitte nur Ziffern und Punkte eingeben, z. B. 1.2.3.</small>
          </div>
          <div class="form-group">
            <a class="btn btn-primary" @click="submitUpdate()">Speichern</a>
          </div>
      </div>
    </div>

    <v-dialog v-model="confirmDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Bestätigen</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Möchten Sie diese Änderung übernehmen?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="sendUpdate()">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emptyDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Fehler</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          {{ emptyDialogMessage }}
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="emptyDialog=false">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>


export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 50,
      sort: null,
      order: true,

      versions: {
          minimum: "",
          recommend: "",
      },
      emptyDialog: false,
      emptyDialogMessage: "",
      confirmDialog: false,
      emptyValidation: false,
    };
  },

  computed: {
    // "Update erforderlich ab" ist Pflicht UND muss ein Versionsformat haben:
    // Ohne diese Prüfung nahm das Formular jeden Text an, obwohl der
    // Versionsvergleich auf dem Server Zahlen mit Punkten erwartet. Welche
    // Folgen ein falsch formatierter Wert dort hat, steht im Kommentar über
    // isValidVersionFormat.
    minimumInvalid() {
      if (!this.emptyValidation) return false;
      if (this.versions.minimum == null || this.versions.minimum === "") return true;
      return !this.isValidVersionFormat(this.versions.minimum);
    },
    // "Update empfehlen ab" bleibt freiwillig — ist aber etwas eingetragen,
    // muss es demselben Format folgen wie "Update erforderlich ab".
    recommendInvalid() {
      if (!this.emptyValidation) return false;
      if (this.versions.recommend == null || this.versions.recommend === "") return false;
      return !this.isValidVersionFormat(this.versions.recommend);
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.getVersions();
  },

  methods: {
    // Erlaubt sind Zahlen, durch Punkte getrennt — mit MINDESTENS einem Punkt
    // (z. B. "1.2", "1.2.3"), nicht bloß "1" und nichts anderes.
    //
    // WARUM das nötig ist — nachgemessen gegen den heutigen Serverstand
    // (ETSBackend/helpers/utils.js, checkVersion; needsUpdate entsteht daraus
    // als "!!minimumVersion && !checkVersion(minimum, appVersion)"):
    //
    //   Mindestversion   App-Version   Zwangsupdate
    //   "1"              9.9.9         nein
    //   "1"              0.0.1         nein
    //   "abc"            1.0.0         nein
    //   "1.2.x"          1.9.0         nein
    //   "1.2.x"          1.1.0         JA
    //   "1.2.x"          0.1.0         JA
    //
    // Zwei verschiedene Schäden, beide ohne jede Rückmeldung:
    //
    // 1. Ein Wert OHNE Punkt ("1", "abc", leer) wird vom Server ausdrücklich
    //    als "kein Zwangsupdate" behandelt (utils.js: "if (!minimumVersion ||
    //    !minimumVersion.includes('.')) return true;" — dort steht ein eigener
    //    WAR-FALSCH-Kommentar dazu). Es sperrt also niemanden aus. Der
    //    Verwalter sieht seinen Eintrag im Formular stehen und hält die Sperre
    //    für aktiv — tatsächlich wirkt sie überhaupt nicht.
    //
    // 2. Ein Wert MIT Punkt, aber unsinnigem Rest ("1.2.x"), rutscht an dieser
    //    Absicherung vorbei. Der Vergleich läuft dann auf Bruchstücke und
    //    entscheidet je nach App-Version willkürlich mal so, mal so: In der
    //    Messung oben wird 1.1.0 zum Update gezwungen, das ÄLTERE 0.1.0
    //    ebenfalls, das NEUERE 1.9.0 dagegen nicht.
    //
    // Die Formatprüfung hier hält beide Fälle vom Server fern. Sie ist kein
    // Ersatz für eine Prüfung im Backend — nur die nächstgelegene Stelle, an
    // der ein Mensch den Tippfehler noch sieht.
    isValidVersionFormat(value) {
      return /^\d+\.\d+(\.\d+)*$/.test(String(value).trim());
    },
    getVersions() {
        const _this = this;
        this.$axios.get('/admin/appversions').then((response) => {
            _this.versions.minimum = response.data.data.minimumVersion;
            _this.versions.recommend = response.data.data.recommendUpdate;
            // ENTFERNT: console.log(_this.versions) — Übrigbleibsel aus der
            // Entwicklung. Das Gegenstück in sendUpdate() war bereits
            // entfernt worden, dieses hier blieb stehen: Bei jedem Öffnen der
            // Seite standen die eingestellten Versionsgrenzen in der
            // Entwicklerkonsole und verrauschten die Fehlersuche.
        }).catch((error) => console.error(error));
    },
    submitUpdate() {
      // WAR FALSCH: Geprüft wurde nur, ob "Update erforderlich ab" leer ist —
      // ein Text wie "abc" oder "1.2.x" ging unverändert durch, und der Server
      // speichert ihn ohne Beanstandung. Erst beim nächsten App-Start entsteht
      // daraus ein unsinniges Ergebnis (Messwerte siehe Kommentar über
      // isValidVersionFormat), und niemand hätte einen Anlass, den Tippfehler
      // dort zu suchen.
      this.emptyValidation = true;
      if (this.minimumInvalid) {
        this.emptyDialogMessage = (this.versions.minimum == null || this.versions.minimum === "")
          ? "Zum Absenden muss zumindest die niedrigste mögliche Version ausgefüllt sein."
          : "Bitte eine gültige Versionsnummer eingeben (nur Ziffern und Punkte, z. B. 1.2.3).";
        this.emptyDialog = true;
        return;
      }
      if (this.recommendInvalid) {
        this.emptyDialogMessage = "Bitte eine gültige Versionsnummer eingeben (nur Ziffern und Punkte, z. B. 1.2.3).";
        this.emptyDialog = true;
        return;
      }
      this.confirmDialog = true;
    },
    sendUpdate() {
        let _this = this;
        const body = _this.versions;
        this.$axios.post('/admin/appversions/update', body).then(function(response) {
            _this.confirmDialog = false;
            _this.emptyValidation = false;
            // WAR FALSCH: Nach dem Speichern passierte optisch gar nichts — der
            // Bestätigungsdialog schloss sich einfach. Ob das Speichern
            // geklappt hat, war nicht zu erkennen.
            _this.$noty.success("Die Versionseinstellungen wurden gespeichert.");
        }).catch(function(error){
            console.error(error);
            _this.confirmDialog = false;
            _this.$noty.error("Die Versionseinstellungen konnten nicht gespeichert werden.");
        })
    }
   },
};


</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>